
/*=========================================================================================
  File Name: getters.js
  namespace: sonar
  Description: Vuex Store - Sonar getters
==========================================================================================*/
const getters = {
    getCurrentSonar: (state) => {
        return state.currentSonar
    },
    getSonarAllStatus: (state) => {
        return Object.entries(state.SONAR_POSSIBLE_STATUS).map(([, value]) => ({
            label:
                value.charAt(0).toUpperCase() +
                value.slice(1).toLowerCase().replace(/_/g, ' '),
            value: value,
        }))
    },
    getSonarList: (state) => {
        return {
            results: state.results,
            count: state.count,
        }
    }
}
export default getters